/**
 * Onboarding channel (canal d'onboarding) — matches the backend OpenAPI enum
 * `onboarding_channel` (see docs/openapi.json): AGENCY | DIGITAL | CBS_IMPORT.
 * Consumed by the KYC scorer for the CANAL factor.
 */
export enum OnboardingChannel {
  AGENCY = "AGENCY",
  DIGITAL = "DIGITAL",
  CBS_IMPORT = "CBS_IMPORT",
}

// Use explicit branching to avoid dynamic object access patterns flagged by detect-object-injection.
// Maps a distribution-channel code (from /parameters/distribution-channels) to the onboarding
// channel enum. Defaults to AGENCY (branch onboarding), which is the only canal in use today.
export function resolveOnboardingChannel(
  channelCode?: string | null,
): OnboardingChannel {
  switch (channelCode) {
    case "3":
    case OnboardingChannel.DIGITAL:
      return OnboardingChannel.DIGITAL;
    case OnboardingChannel.CBS_IMPORT:
      return OnboardingChannel.CBS_IMPORT;
    case "2":
    case OnboardingChannel.AGENCY:
    default:
      return OnboardingChannel.AGENCY;
  }
}
